import { useSetNewPriceState, useSetPriceSuccessState } from "@/shared/client";
import { API_ROOMS, type RoomPriceInfoResponse } from "@/shared/server";
import { useMutation } from "@tanstack/react-query";

export const useHandlePrice = () => {
    const setIsPriceStatus = useSetPriceSuccessState();
    const setPriceNewData = useSetNewPriceState();

    const mutation = useMutation({
        mutationFn: API_ROOMS.getRoomInfo<RoomPriceInfoResponse>,
        onMutate: () => {
            setIsPriceStatus(false);
        },
        onSuccess: (data) => {
            setPriceNewData(data);
            setIsPriceStatus(true);
        },
    });

    return mutation;
};
